import AppNavbar from "./component/Navbar";
import "./App.css";
import { Alert, Button } from "react-bootstrap";


export default function UserGuide() {
    return(
        <div>
            <AppNavbar/>
            <div className="User-guide">
                <h1>漢文クイズプレーヤー使用ガイド</h1>
                <br/>
                <h2>このツールについて</h2>
                <p>
                    問題文をもとに漢文クイズ（問題文の漢字のみを先に表示し、後からそれ以外の文字が間に足されていくクイズ）を表示することができます。
                </p>
                <br/>
                <img src="images\UserGuide\Player1_high.gif" alt="" width={800}/>
                <br/>
                <h2>必要なもの</h2>
                <ul>
                    <li>問題が書かれたGoogleスプレッドシート</li>
                </ul>
                <br/>
                <h2>スプレッドシートの書き方</h2>
                <p>
                    ツールに問題を読み込ませるためにはいくつかのルールを守る必要があります。具体的には
                    <ul>
                        <li>シートの1行目は読み込まれません。</li>
                        <li>問題文はシートのB列に記入してください。</li>
                        <li>問題の答えはシートのC列に記入してください。答えを表示したくない問題は空欄にしてください。</li>
                    </ul>
                    ルール通りにシートを書くとこんな感じになります。
                    <img src="images/UserGuide/Sheet1.png" alt="シートの記入例" width={800}/>
                    <br/><br/>
                    実際に読み込めるサンプルシートはこちら。<br/>
                    <br/>
                    <Button href="https://docs.google.com/spreadsheets/d/1vW8GsMAmVXl1zJRJ3zXO97MzOqykDzxBgQY0QfdwzUc/edit?usp=sharing" target="_blank">
                    漢文クイズプレーヤーサンプルシート
                    </Button>
                </p>
                <br/>
                <h2>問題設定の方法</h2>
                <br/>
                <h3>スプレッドシート側での操作</h3>
                <p>
                    問題を読み込むには、スプレッドシートのアクセス権を設定する必要があります。<br/>
                    スプレッドシートの右上にある「共有」ボタンを押して、「一般的なアクセス」を「リンクを知っている全員」「閲覧者」に設定します。<br/>
                    設定したら「リンクをコピー」ボタンをクリックして共有URLをコピーしておきましょう。<br/>
                </p>
                <br/>
                <Alert variant="danger">
                    <Alert.Heading>注意！</Alert.Heading>
                    <p>
                        この工程で共有したスプレッドシートはリンクさえあれば誰でも閲覧できる状態になります。公開していない問題を使用する際は気を付けてください。
                    </p>
                </Alert>
                <br/>
                <img src="images/UserGuide/ShareSheet1.png" alt="シートの共有URLとシート名のフォーム" width={800}></img>
                <br/><br/>
                <h3>Player側での操作</h3>
                <p>
                    Player画面上部の「Open Settings」ボタンを押すと問題を読み込むためのフォームが開きます。
                    <ul>
                        <li>シートの共有URL：先ほどコピーしたURL</li>
                        <li>読み込むシートの名前：問題が書かれたシート名（サンプルならkanbunabcなど）</li>
                    </ul>
                    これらを入力して「Set Question」を押せば問題が読み込まれるはずです。
                    <img src="images/UserGuide/SetQuestion1.png" alt="シートの共有URLとシート名のフォーム" width={800}></img>
                </p>
                <br/><br/>
                <h2>注意事項</h2>
                <p>
                    <ul>
                        <li>ツールの使用は自己責任でお願いします</li>
                        <ul>
                            <li>特に共有リンクの漏洩などには十分気を付けるようお願いします</li>
                        </ul>
                        <li>大会やイベント等で使用する際は一声かけていただけると制作者が非常に喜びます</li>
                        <li>バグ報告や質問、使用報告などはSma(Twitter:@gouwanowan)まで</li>
                    </ul>
                </p>
                <h2>参考記事</h2>
                <ul>
                    <li>
                        <a href="https://qiita.com/M_yuhki/items/d5696c25371eee97d9da">どうしても漢文テクニカルクイズがやりたかったので自分で作った話</a>
                    </li>
                    <ul>
                        <li>
                            問題文表示のロジックなどを参考にしています
                        </li>
                    </ul>
                </ul>
            </div>
        </div>
    )
}